import { useState, useContext } from 'react';
import { UserContext } from '../context/UserContext';
import { canCreateCustomer as canCreateFromInfo } from '../components/CustomerLimitBanner';

/**
 * Custom hook for managing customer limit cache state
 * 統一管理客戶數量限制快取狀態，避免按鈕閃爍問題
 */
export const useCustomerLimitCache = () => {
  const userContext = useContext(UserContext);
  const { user } = userContext!;

  // 客戶數量限制狀態 - 從快取初始化避免閃爍
  const [canAddCustomer, setCanAddCustomer] = useState(() => {
    if (!user?.organizationId) return true;
    try {
      const cached = localStorage.getItem(`customer-limit-${user.organizationId}`);
      if (cached) {
        const limitInfo = JSON.parse(cached);
        return limitInfo.isWithinLimit;
      }
    } catch {
      // 快取讀取失敗，使用預設值
    }
    return true;
  });

  // 還能新增客戶（等於上限就不行；客戶列表的新增按鈕用）
  const [canCreateCustomer, setCanCreateCustomer] = useState(() => {
    if (!user?.organizationId) return true;
    try {
      const cached = localStorage.getItem(`customer-limit-${user.organizationId}`);
      return cached ? canCreateFromInfo(JSON.parse(cached)) : true;
    } catch {
      return true;
    }
  });

  // CustomerLimitBanner 刷新觸發器
  const [limitBannerRefreshTrigger, setLimitBannerRefreshTrigger] = useState(0);

  return {
    canAddCustomer,
    setCanAddCustomer,
    canCreateCustomer,
    setCanCreateCustomer,
    limitBannerRefreshTrigger,
    setLimitBannerRefreshTrigger,
  };
};